import eventBus from './eventBus';
import ToastNotifications from '../modules/components/toast-notifications.vue';

export default {
  install(Vue, config) {
    const baseOptions = {
      ...{
        duration: 3000
      },
      ...config
    };

    Vue.component('ToastNotifications', ToastNotifications);

    Vue.prototype.$notify = options => {
      eventBus.$emit('notify', { ...baseOptions, ...options });
    };
  }
};
